import { PLANS_PERMISSIONS_ANONYMOUS } from "../selector";

const hasPermissionRedux = ({ userData }) => ({ permissions }) => {
  const userPermissions = [...(userData?.permissions ?? [])] ?? [];

  const anonymousPermissions = PLANS_PERMISSIONS_ANONYMOUS;

  return (permissions ?? []).every(permission =>
    [...userPermissions, ...anonymousPermissions].includes(permission)
  );
};

export default hasPermissionRedux;
